import _ from "lodash";
import modelBaseV2 from "../model-base-v2.model";
import moment from "moment";

var photoModel = {

    getPhotoList: function (filter) {
        // Set required default values
        const params = {
            pageIndex: 1,
            pageSize: 10,
        }

        Object.assign(params, filter);

        return modelBaseV2.post('/api/photo/list', { body: params });
    },

    exportPhotoListToExcel: function (filter, fileName = `Photo List - ${moment().format('YYYYMMDDHHmm')}.xlsx`) {
        return modelBaseV2.postDownload('/api/photo/file/excel', { body: filter }, fileName);
    },

    exportPhotoListToPptx: function (filter, fileName = `Photo List - ${moment().format('YYYYMMDDHHmm')}.pptx`) {
        return modelBaseV2.postDownload('/api/photo/file/pptx', { body: filter }, fileName);
    },

    getPictureTypeList: function () {
        return modelBaseV2.get('/api/codemaster/PIC_TYPE');
    },

    getAllImagesByPhotoId: function (photoId = '') {
        photoId = encodeURIComponent(photoId);
        return modelBaseV2.get(`/api/photo/photofile?photoId=${photoId}`);
    },

    /**
     * Temp request function for Type 2 Photo Download
     */
    downloadType2Photos: (body, fileName = `Type 2 Photos - ${moment().format('YYYYMMDDHHmm')}.zip`) => {
      return modelBaseV2.postDownload('/api/photo/file/excel/imeitype2', { body }, fileName);
    },

}

export default photoModel;
